export {};

declare global {
  interface Object {
    let<T, R>(this: T, block: (self: T) => R): R;
    also<T, R>(this: T, block: (self: T) => R): T;
    apply<T, R>(this: T, block: (this: T) => R): T;
    takeIf<T>(this: T, predicate: (self: T) => boolean): T | null;
  }
}

const _let = function <T, R>(this: T, block: (obj: T) => R): R {
  return block(this);
};

const _also = function <T, R>(this: T, block: (self: T) => R): T {
  block(this);
  return this;
};

const _apply = function <T, R>(this: T, block: (this: T) => R): T {
  block.call(this);
  return this;
};

const _takeIf = function <T>(this: T, predicate: (self: T) => boolean): T | null {
  return predicate(this) ? this : null;
};

export const defineProp = function <T>(obj: T, name: string, func: unknown) {
  Object.defineProperty(obj, name, { enumerable: false, value: func });
};

if (!Object.prototype.let) {
  defineProp(Object.prototype, 'let', _let);
  defineProp(Object.prototype, 'also', _also);
  defineProp(Object.prototype, 'apply', _apply);
  defineProp(Object.prototype, 'takeIf', _takeIf);
}

export const emptySet = <K>() => new Set<K>();
export const emptyMap = <K, V>() => new Map<K, V>();
export const emptyArray = <T>() => new Array<T>();
export const mapOf = <K, V>(entries?: readonly (readonly [K, V])[]) => new Map<K, V>(entries);
